export default __webpack_public_path__ + "static/media/slider_image1.8f23daed.jpg";